import { jsx as _jsx } from "react/jsx-runtime";
import { checkForFestgeldQueryParams } from 'routes/klarnaMarketing/utils/festgeld';
import styled from 'styled-components';
const StyledButtonGroup = styled.div.withConfig({
    componentId: "sc-5dd6f465-0"
})([
    `display:flex;flex-wrap:wrap;`,
    `;`,
    `;`,
    `;gap:24px;&:not(:last-child){margin-bottom:24px;}align-items:center;`
], (p)=>p.center && `justify-content: center`, (p)=>p.$isAffiliateTraffic && `.button--affiliate + .button{
    display: none
  }
  }`, (p)=>!p.$isAffiliateTraffic && `.button--affiliate {
    display: none
  }
  }`);
const ButtonGroup = ({ children, center })=>{
    // check if the incoming traffic is affiliated for festgeld page
    const isAffiliateTraffic = checkForFestgeldQueryParams();
    return /*#__PURE__*/ _jsx(StyledButtonGroup, {
        $isAffiliateTraffic: isAffiliateTraffic,
        center: center,
        children: children
    });
};
export default ButtonGroup;
